import { Controller } from "@hotwired/stimulus"
import Cookies from 'js-cookie'

export default class extends Controller {
  static values = {
    isReady: Boolean
  }

  connect() {
    this.faqMessageReadDelay = 250
    this.welcomeMessageSendDelay = 80000
  }

  isReadyValueChanged() {
    if (this.isReadyValue) {
      this.onCrispReady()
    }
  }

  onCrispReady() {
    if (window.$crisp && typeof $crisp.is === 'function') {
      this.setMessageCallbacks()

      setTimeout(() => {
        if (window.$crisp.is("session:ongoing") == false && Cookies.get('sent_crisp_faq') === undefined) {
          this.sendFaqMessages()
          Cookies.set('sent_crisp_faq', true)
        }

        if (Cookies.get('sent_crisp_welcome') === undefined) {
          setTimeout(this.sendWelcomeMessage.bind(this), this.welcomeMessageSendDelay)
        }
      }, 250)
    }
  }

  setMessageCallbacks() {
    $crisp.push(["on", "message:sent", function(message) {
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'ChatWidget',
          'conversionValue': 15.00
        })
      }
      // if (window.gtag) {
      //   gtag('event', 'ChatWidget', { event_category: 'Lead', currency: 'USD', value: 15.00 })
      //   gtag('event', 'conversion', {'send_to': 'AW-779913037/EFVwCM6Q54cYEM2O8vMC', 'currency': 'USD', 'value': 15.00})
      // }
      // if (window.fbq) {
      //   fbq('trackCustom', 'Chat Widget', { currency: 'USD', value: 15.00 });
      // }
      // if (window.uetq) {
      //   window.uetq.push('event', 'chat_widget', {"revenue_value":15.00,"currency":"USD"});
      // }
    }]);

    $crisp.push(["on", "user:email:changed", function(email) {
      if (email) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "<%= fwd_to_api_email_leads_path %>?email=" + email, true);
        xhr.send();

        if (window.dataLayer) {
          window.dataLayer.push({
            'set': 'user_data',
            'sha256_email_address': sha256(email)
          })
        }
        // if (window.gtag) {
        //   window.gtag('set', 'user_data', { "sha256_email_address": sha256(email) })
        // }
      }
    }]);
  }

  sendFaqMessages() {
    const message = `
##### Is this Roundup Ready™️ / What can I spray with?\n
No, it is not RoundUp Ready™️ / glyphosate tolerant. However, you can spray it with pretty much anything else you're used to spraying your crops with.\n\nMany people utilize glyphosate or other glyphosate products to kill weeds before planting as a pre-plant burndown. You just can't spray it with glyphosate after planting.\n\nAs far as herbicide program, I would reach out to your local chemical dealer or coop.\n\nHowever, some simple recommendations based on no till:\n\n* Grass control is the most important weed issue with conventional/non-gmo corn. You can utilize a burndown such as glyphosate, but cannot spay over growing crop. It is recommended to use a good pre-emergent such as Dual II Magnum, Harness, Outlook, or Surpass NXT if you are no-till.\n\n* Accent Q, Impact, and Capreno are examples of herbicides that can be used post emergence for grass control in corn.\n\n* Broadleaf weeds can be controlled with Atrazine, Status, and 2,4-D or any other broadleaf herbicide labeled for use in corn. While we hope this helps, we recommend getting in contact with your local chemical dealer for more detailed instructions.
\n
##### What is the yield potential of this corn?\n
You can view some farmer-provided yields as well as a plot trial on our results page at: http://hybrid85.com/results.
\n
##### What is a unit / bag? How many lbs per bag?\n
Each bag has 80,000 kernels. Weights vary by kernel size, but average bag weight is 50 lbs.
\n
##### Can I get untreated seed?\n
Yes! During our checkout process, we ask if you would like your seed treated or non treated. Many of our growers have successfully used our provided Non-GMO affidavit with their Organic Certifier without any issues.`

    $crisp.do('message:show', ["text", message])
    setTimeout(() => {
      $crisp.do("message:read")
    }, this.faqMessageReadDelay)
  }

  sendWelcomeMessage() {
    if (window.$crisp.is("chat:closed")) {
      window.$crisp.do('message:show', ["text", "Hi there! Here are a list of some commonly asked questions. Please click the chat icon in the bottom right corner to chat with us!"])
    }

    Cookies.set('sent_crisp_welcome', true)
  }

  async sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder('utf-8').encode(message);

    // hash the message
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');

    return hashHex;
  }

}